import type { Pack } from '@bcl/shared';
import { api } from '@/lib/api';

export async function listActivePacks(): Promise<Pack[]> {
  const { data } = await api.get<Pack[]>('/packs');
  return data;
}
